import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["contentLink", "issueKey"],
  _excluded2 = ["cloudId", "issueKey", "commentId", "issueAri", "projectId", "projectType"];
import React from 'react';
import { di } from 'react-magnetic-di';
import { triggerJiraIssueCommentLoadedAnalytics, useCreateFireAnalyticsFromTrigger } from '../../../../utils/analytics';
import { useExperienceTracker } from '../../../../utils/experience-tracking/adapter/context';
import { ErrorBoundarySuspense } from '../../../error-boundary-suspense';
import { ReactionsPlaceholder } from '../../reactions-placeholder';
import { ReactionsBar } from './reactions-bar/main';
export var JIRA_REACT_BAR_EVENTS = ['streamhub-jira-comment-mention', 'streamhub-jira-comment-create'];
export var JiraReactBar = function JiraReactBar(_ref) {
  var contentLink = _ref.contentLink,
    issueKey = _ref.issueKey,
    others = _objectWithoutProperties(_ref, _excluded);
  if (!issueKey) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ErrorBoundarySuspense, {
    subjectId: "jiraCommentNotificationReactionBar",
    loadingFallback: /*#__PURE__*/React.createElement(ReactionsPlaceholder, null),
    errorFallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, /*#__PURE__*/React.createElement(InnerJiraReactBar, _extends({
    issueKey: issueKey
  }, others)));
};
var InnerJiraReactBar = function InnerJiraReactBar(_ref2) {
  var cloudId = _ref2.cloudId,
    issueKey = _ref2.issueKey,
    commentId = _ref2.commentId,
    issueAri = _ref2.issueAri,
    projectId = _ref2.projectId,
    projectType = _ref2.projectType,
    others = _objectWithoutProperties(_ref2, _excluded2);
  var commentAri = "ari:cloud:jira:".concat(cloudId, ":comment/").concat(commentId);
  if (issueAri) {
    return /*#__PURE__*/React.createElement(ReactionsBar, _extends({
      projectId: projectId,
      projectType: projectType,
      issueAri: issueAri,
      commentAri: commentAri
    }, others));
  }
  return null;
};